import React, { CSSProperties, useEffect, useState } from 'react';
import { Avatar } from '@mui/material';

type BlurryLoadingImageProps = {
    preview: string;
    image: string;
    alt?: string;
    imageStyleClass?: string;
    divStyleClass?: string;
    bgColor?: string;
    minHeight?: number | string;
    style?: CSSProperties;
    onClick?: () => void;
};

const BlurryLoadingImage = ({
    preview,
    image,
    alt,
    imageStyleClass,
    divStyleClass,
    bgColor = 'transparent',
    minHeight,
    style = undefined,
    onClick = () => {},
}: BlurryLoadingImageProps) => {
    const [currentImage, setCurrentImage] = useState(preview);
    const [loading, setLoading] = useState(true);

    const fetchImage = (src: string) => {
        const loadingImage = new Image();
        loadingImage.src = src;
        loadingImage.onload = () => {
            setCurrentImage(loadingImage.src);
            setLoading(false);
        };
    };

    useEffect(() => {
        fetchImage(image);
    }, [image]);

    return (
        <div className={divStyleClass} style={{ overflow: 'hidden', width: 'fit-content' }}>
            <Avatar
                sx={{
                    filter: `${loading ? 'blur(6px)' : ''}`,
                    transition: `150ms filter linear, ${style?.transition ?? ''}`,
                    background: bgColor,
                    width: 'auto',
                    minHeight,
                    ...style,
                }}
                src={currentImage}
                alt={alt}
                onClick={onClick}
                className={imageStyleClass}
            />
        </div>
    );
};

export default BlurryLoadingImage;
